import React from 'react'

import { ZoneStateWarning } from '@/core/api/entities/zone/state'
import { useTranslation } from '@/core/i18n/useTranslation'
import { Badge } from '@/shared/components/atoms/Badge/Badge'

interface AlertsBadgesProps {
	warnings: ZoneStateWarning[]
	showHeading?: boolean
	headingClassName?: string
	containerClassName?: string
	badgeClassName?: string
}

export const AlertsBadges: React.FC<AlertsBadgesProps> = ({
	warnings,
	showHeading = true,
	headingClassName = 'text-xl font-semibold mb-2',
	containerClassName = 'mb-12',
	badgeClassName = 'bg-status-warning/20 text-status-warning text-sm font-medium px-3 py-1 border-none',
}) => {
	const { t } = useTranslation('zones')

	if (!warnings || warnings.length === 0) {
		return null
	}

	return (
		<div className={containerClassName}>
			{showHeading && (
				<h2 className={headingClassName}>
					{warnings.length}{' '}
					{warnings.length === 1 ? t('card.alert') : t('card.alerts')}
				</h2>
			)}
			<div className="flex flex-wrap gap-2">
				{warnings.map((warning, index) => (
					<Badge key={index} variant="zones" className={badgeClassName}>
						{warning.message}
					</Badge>
				))}
			</div>
		</div>
	)
}
